<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
        @sendWarehouse="batchSendWarehouse"
        @clearCheckboxRow="clearCheckboxRow"
        :checkedCount="checkedCount"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader },
  data() {
    return { usePage: true, checkedRow: [] }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyNoticeInListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          // this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    async batchSendWarehouse() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_sendWarehouse') || '是否要进行通知送仓操作？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const amzFtyNoticeInCodeList = this.checkedRow.map(
        (row) => row.amzFtyNoticeInCode
      )
      const res = await this.$api
        .ecomAmzFtyNoticeInSendWarehouseApi({
          amzFtyNoticeInCodeList: amzFtyNoticeInCodeList,
        })
        .catch(() => null)
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('通知失败！')
        return
      }
      this.$refs.header.query()
      this.clearCheckboxRow()
      this.$message({ showClose: true, message: '通知成功！', type: 'success' })
    },
    clearCheckboxRow() {
      this.checkedRow = []
      this.$refs.main.clearCheckboxRow()
    },
    openEditPage({ pageType, data = {} }) {
      const {
        amzFtyNoticeInCode = '',
        amzFtyNoticeInNo = '',
        amzFtyNoticeInStatus = '',
      } = data
      let params = { pageType }
      let query = {}
      if (amzFtyNoticeInCode) params = { ...params, amzFtyNoticeInCode }
      if (amzFtyNoticeInStatus) params = { ...params, amzFtyNoticeInStatus }
      if (amzFtyNoticeInNo) query = { ...query, amzFtyNoticeInNo }
      this.$router.push({
        name: 'ecom-awsBiz-ftyInvInNotice-detail',
        params,
        query,
      })
    },
  },
}
</script>
